const BankPayment = () =>
  import(
    /* webpackChunkName: "financial-payment-bank-payment" */ '@/pages/financial/payment/bank-payment/index.vue'
  )

export default {
  path: 'bank-payment',
  meta: {
    label: 'payment',
    auth: 'payment'
  },
  component: {
    name: 'Payment',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialPaymentBankPayment',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: BankPayment
    }
  ]
}
